import React from 'react'
import View from './view'

type Props = {
  flashcardDeckId?: string
  courseId?: string
  isStudyGuide?: boolean
  assetGlobalId?: number
  studyDay?: number
}

const FlashCards = ({
  flashcardDeckId,
  courseId,
  isStudyGuide,
  assetGlobalId,
  studyDay,
}: Props) => {
  return (
    <View
      flashcardDeckId={flashcardDeckId}
      propsCourseId={courseId}
      isStudyGuide={isStudyGuide}
      assetGlobalId={assetGlobalId}
      studyDay={studyDay}
    />
  )
}

export default FlashCards
